// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"136":"f18f1335","277":"41bcef79","787":"d5fa4d18"}[chunkId] + ".chunk.js";
};